export default __webpack_public_path__ + "static/media/Shadow's Belt of the Hidden Palace.53241e38.jpg";